import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Store
import { injectReducer } from 'store/reducers';

// Components
import StaticLoader from 'components/Loader/StaticLoader';

/**
  This is code from this article:
  https://serverless-stack.com/chapters/code-splitting-in-create-react-app.html
**/

export default function asyncComponent(importedComponent, reducer, key) {
  class AsyncComponent extends Component {
    static propTypes = {
      store: PropTypes.object,
    };

    constructor(props) {
      super(props);

      this.state = {
        component: null,
      };
    }

    async componentDidMount() {
      if (reducer && key) {
        injectReducer({ key, reducer });
      }

      const { default: component } = await importedComponent();

      this.setState({
        component,
      });
    }

    render() {
      const Component = this.state.component;

      if (!Component) {
        return <StaticLoader />;
      }

      return <Component {...this.props} />;
    }
  }

  return AsyncComponent;
}
